import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/performance")({
  component: lazyRouteComponent(() => import("./-pages/admin.performance")),
  head: () => ({
    meta: [
      { title: "أداء الموقع · Lecmo Admin" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
